module.exports = __webpack_public_path__ + "static/media/ade.f5d50610.jpg";